const norm = (s) => String(s || "").toLocaleUpperCase("tr-TR").replace(/\s+/g, " ").trim();
const normPlate = (s) => String(s || "").toUpperCase().replace(/[^A-Z0-9]/g, "");
const day = (s) => String(s || "").slice(0, 10);

// Renewal key: same customer + branch (+ plate for vehicle policies). Police no / company may change.
const keyOf = (p) => `${norm(p.customer)}|${norm(p.branch)}|${normPlate(p.plate)}`;

export function findRenewedIds(policies) {
  const live = policies.filter((p) => (p.status || "aktif") !== "iptal" && !p.deletedAt && p.end);
  const groups = {};
  live.forEach((p) => { (groups[keyOf(p)] ||= []).push(p); });
  const ids = new Set();
  Object.values(groups).forEach((list) => {
    if (list.length < 2) return;
    list.forEach((p) => {
      if (list.some((q) => q.id !== p.id && day(q.end) > day(p.end) && day(q.start || q.end) >= day(p.start || ""))) ids.add(p.id);
    });
  });
  return ids;
}

export const noteHistory = (p) => {
  const h = Array.isArray(p.renewalNoteHistory) ? p.renewalNoteHistory : [];
  if (h.length) return h;
  return p.renewalNote ? [{ note: p.renewalNote, at: p.renewalNoteAt }] : [];
};

const CALL_RE = /arad|aran|ulaşılama|ulasilama|telefon|açmadı|acmadi|meşgul/i;
export const callCount = (p) => noteHistory(p).filter((h) => CALL_RE.test(h.note || "")).length;

export const LOST_NOTE = "Başka şirkete geçti";
export const isLost = (p) => /başka şirkete geçti|baska sirkete gecti/i.test(p.renewalNote || "");
export const LOST_REASONS = ["Fiyat", "Hizmet", "Başka acente", "Teminat yetersiz", "Araç satıldı", "Diğer"];
